export const INVESTMENT_API = `v1/home/holding`;
